<template>
  <div class="form-group">
    <strong class="label-holder">
      <label :for="id">{{ $t(label) }}</label>
    </strong>
    <div class="field" :class="{ 'error' : invalid }">
      <input 
        v-model="inputValue" 
        :type="type" 
        class="form-control" 
        :class="{ 'errorInput' : invalid }"
        :id="id"
        @blur="$emit('change')"
        @focusout="$emit('focusout')"
        :disabled="disabled"
        @keyup.enter="submit && $emit('keyup')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "input-base",
  props: {
    id: { type: String, default: 'field', required: true },
    value: { required: true },
    type: { type: String, default: 'text' },
    label: { type: String, required: true },
    invalid: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    submit: { default: false }
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>